import React from 'react';
import _404 from '../../assets/404.svg';
import style from '../../style/blog.module.css';
import Connect from '../../components/Connect'

export default function Blog() {
  return (
    <div className={style.blog}>
      <div className={style.blogLeft}>
        <h1>Coming soon...</h1>
        <p>I am organizing my content right now, but will be available soon!</p>
        <Connect />
      </div>
      <img className={style.blogRight} src={_404} />
    </div>
  )
}
